import React from 'react';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { useAppTakeoverPdp } from 'components/app-takeover/use-app-takeover';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';
import { t } from 'state/intl/translations';

import { useProductWizardContext } from '../../product-wizard';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';

interface IUpdateItemCtaProps {
  eventAttributes: { name: string; Id: string; modifierSelections: string[] };
}

export const UpdateItemCta = ({ eventAttributes }: IUpdateItemCtaProps) => {
  const { clearSlotsSelectionSnapshot, slotsSelections } = useProductWizardContext();
  const { goToPreviousStep, currentFlowStep, id } = useProductWizardFlow();
  const { isTakeoverActive } = useAppTakeoverPdp(id);

  const handleSubmit = () => {
    clearSlotsSelectionSnapshot();
    goToPreviousStep();

    logButtonClick({
      attributes: {
        component: ClickEventComponentNames.PRODUCT_UPDATE_ITEM,
        name: eventAttributes.name,
        Id: eventAttributes.Id,
        modifierSelections: eventAttributes.modifierSelections,
      },
    });
  };

  return (
    <ActionButton
      testID="product-customization-action-button"
      disabled={!slotsSelections[currentFlowStep.slotKey!]}
      flex={1}
      onPress={handleSubmit}
      variant={
        isTakeoverActive ? ActionButtonVariants.PRIMARY_TAKEOVER : ActionButtonVariants.PRIMARY
      }
    >
      {t('updateItem')}
    </ActionButton>
  );
};
